import React, { Component } from "react"
import { Alert, Card, CardBody, Col, Container, Row, Spinner } from "reactstrap"
import { AvField, AvForm } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"
import { Profile, Logo } from "./Fragments"

const apiUrl = "https://register.idexo.io/"

const passwordVerify = (value, ctx) => {
    if (ctx.password !== ctx.confirmpassword) {
        return "Passwords didn't match. Try again."
    }
    return true
}
class Register extends Component {
    constructor(props) {
        super(props)
        this.state = {
            email: "",
            password: ""
        }

        this.registerUser = this.registerUser.bind(this)
    }

    registerUser(event, { email, password }) {
        this.setState({ alertMessage: "", alertColor: "", showSpinner: true })
        let span = document.getElementById("logoSpan")
        span.style = "animation-name: anim;"
        return fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email,
                password: password,
                type: "new"
            }),
            json: true
        })
            .then((res) => res.json())
            .then((data) => {
                console.log("Success: ", data)
                // localStorage.setItem('jwtToken', data)
                if (data.error) {
                    this.setState({ alertColor: "danger", alertMessage: "Error: " + data.error, showSpinner: false })
                } else {
                    this.setState({
                        alertColor: "success",
                        alertMessage: "Registration submitted. Check your email for further instructions.",
                        showSpinner: false
                    })
                }
                span.style = ""
            })
            .catch((error) => {
                console.log(error)
                this.setState({ showSpinner: false })
            })
    }

    render() {
        return (
            <React.Fragment>
                <div className="home-btn d-none d-sm-block">
                    <Link to="/" className="text-dark">
                        <i className="bx bx-home h2" />
                    </Link>
                </div>
                <div className="account-pages my-5 pt-sm-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="overflow-hidden">
                                    <Profile title="Free Register" message="Get your free idexo account now."></Profile>
                                    <CardBody className="pt-0">
                                        <Logo></Logo>
                                        <div className="p-2">
                                            <AvForm className="needs-validation" onValidSubmit={this.registerUser} autocomplete="off">
                                                {this.state.alertMessage ? (
                                                    <Alert color={this.state.alertColor}>{this.state.alertMessage}</Alert>
                                                ) : null}

                                                <div className="mb-3">
                                                    <AvField
                                                        name="email"
                                                        label="Email"
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        type="email"
                                                        required
                                                        autocomplete="off"
                                                        disabled={this.state.showSpinner}
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <AvField
                                                        name="password"
                                                        label="Password"
                                                        type="password"
                                                        required
                                                        placeholder="Enter Password"
                                                        autocomplete="off"
                                                        validate={{
                                                            required: { value: true },
                                                            minLength: {
                                                                value: 10,
                                                                errorMessage: "Your password must be at least 10 characters"
                                                            },
                                                            pattern: {
                                                                value: "^(?=.*[A-Z])(?=.*[!@#&%=,;:<>^$.|?*+()])(?=.*[0-9])(?=.*[a-z]).*$",
                                                                errorMessage: "Password must have Uppercase, Numbers and Symbols."
                                                            }
                                                        }}
                                                        disabled={this.state.showSpinner}
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <AvField
                                                        name="confirmpassword"
                                                        label="Confirm Password"
                                                        type="password"
                                                        required
                                                        placeholder="Confirm Password"
                                                        autocomplete="off"
                                                        validate={{
                                                            myValidation: passwordVerify
                                                        }}
                                                        disabled={this.state.showSpinner}
                                                    />
                                                </div>

                                                <div className="mt-4 d-grid">
                                                    <button
                                                        className="btn btn-primary btn-block waves-effect waves-light"
                                                        type="submit"
                                                        disabled={this.state.showSpinner}
                                                    >
                                                        {this.state.showSpinner ? (
                                                            <React.Fragment>
                                                                Registering...
                                                                <Spinner
                                                                    style={{ width: "0.7rem", height: "0.7rem", marginLeft: "1rem" }}
                                                                    color="light"
                                                                />
                                                            </React.Fragment>
                                                        ) : (
                                                            "Register"
                                                        )}
                                                    </button>
                                                </div>

                                                <div className="mt-4 text-center">
                                                    <p className="mb-0">
                                                        By registering you agree to the idexo{" "}
                                                        <Link to="#" className="text-primary">
                                                            Terms of Use
                                                        </Link>
                                                    </p>
                                                </div>
                                            </AvForm>
                                        </div>
                                    </CardBody>
                                </Card>
                                <div className="mt-5 text-center">
                                    <p>
                                        Already have an account ?{" "}
                                        <Link to="/login" className="fw-medium text-primary">
                                            {" "}
                                            Login
                                        </Link>{" "}
                                    </p>
                                    <p>© {new Date().getFullYear()} idexo.io</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

export default Register
